import { api, ReactQueryOptions } from '@api';
import { useShowToast } from '@hooks/useShowToast';
import { PostView } from '@data/post/PostManagerSpec';
import { PreviewService } from '../helpers';
type ContextType = {
  prevData: PostView | null | undefined;
  post_id: number;
};
type optionsType = ReactQueryOptions['PostsManager']['update'];
export const useUpdatePost = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const utils = api.useUtils();
  return api.PostsManager.update.useMutation({
    mutationKey: ['PostsManager.update'],
    onError: (_, __, context) => {
      const _context = context as ContextType | undefined;
      const post_id = _context?.post_id;
      const prevData = _context?.prevData;
      if (prevData && post_id) {
        utils.PostsManager.getPost.setData({
          post_id
        }, prevData);
      }
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onMutate: async opts => {
      await utils.PostsManager.getPost.cancel({
        post_id: opts.id
      });
      const prevData = utils.PostsManager.getPost.getData({
        post_id: opts.id
      });
      if (!prevData) return {
        prevData,
        post_id: opts.id
      };
      const title = PreviewService.getHeadingText(opts.content_new);
      utils.PostsManager.getPost.setData({
        post_id: opts.id
      }, {
        ...prevData,
        edited_at: new Date(),
        content_new: opts.content_new,
        id: opts.id,
        type: opts.type,
        author_id: opts.author_id,
        title: title
      });
      return {
        prevData,
        post_id: opts.id
      };
    },
    ...options
  });
};